import { render, staticRenderFns } from "./WhReturnDetail.vue?vue&type=template&id=5bde8870"
import script from "./WhReturnDetail.vue?vue&type=script&lang=js"
export * from "./WhReturnDetail.vue?vue&type=script&lang=js"
import style0 from "./WhReturnDetail.vue?vue&type=style&index=0&id=5bde8870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports